import { useInstantSearch, useMenu, useStats } from 'react-instantsearch';
import useRelatedRefinementList from './filters/custom/useRelatedRefinementList';
import { buildCurrentSearchLabel } from './helpers';
import useRedirectURL from './hooks/useRedirectURL';
import type { HasMotabilityState } from '@javascript/types/InstantSearch';
import classNames from 'classnames';
import InstantSearchBranchChip from './instantSearchBranchChip';

export type InstantSearchStatusProps = {
  branches?: Record<string, string>;
} & HasMotabilityState;

const ConditionsMenu = () => useMenu({ attribute: 'conditions' });

const InstantSearchStatus = ({
  isMotability,
  branches,
}: InstantSearchStatusProps) => {
  const { nbHits } = useStats();
  const { status } = useInstantSearch();
  const redirectURL = useRedirectURL();

  const { items: conditions } = isMotability ? { items: [] } : ConditionsMenu();

  const { items: makes } = useRelatedRefinementList({
    attribute: 'makeModel.make',
    relatedAttributes: [],
  });
  const { items: models } = useRelatedRefinementList({
    attribute: 'makeModel.model',
    relatedAttributes: [],
  });

  const { items: branchIDs, refine } = useMenu({ attribute: 'branchID' });

  const selectedBranchID = branchIDs.find((item) => item.isRefined)?.label;

  const selectedBranch = selectedBranchID && branches?.[selectedBranchID];

  const label = buildCurrentSearchLabel({
    conditions,
    makes,
    models,
    nbHits,
    isMotability,
  });

  if (status === 'loading' || status === 'stalled') {
    return (
      <div className="ch-mt--4 sm:ch-mt--6 ch-ph--2 ch-fs--3 sm:ch-fs--4 sm:ch-text--center">
        <div className="search-status-loading-div" />
        {((!nbHits && branches) || selectedBranch) && (
          <div className="search-status-loading-div" />
        )}
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'ch-container ch-mt--4 ch-ph--2 sm:ch-text--center',
        `sm:ch-m${isMotability && !nbHits ? 'v' : 't'}--6`
      )}
    >
      {isMotability && (
        <div className="sm:ch-absolute ch-mb--3 sm:ch-mb--0 ch-text--left">
          <a
            className="ac-instant-search__motability-back ch-pl--3 ch-fs--3"
            href="/vehicles"
          >
            Search all cars
          </a>
        </div>
      )}
      {!nbHits || redirectURL ? null : (
        <>
          <h1 className="ch-fs--3 sm:ch-fs--4">
            {selectedBranch ? label + ' at' : label}
          </h1>
          {selectedBranch && (
            <InstantSearchBranchChip
              branchName={selectedBranch}
              resetBranch={() => refine('')}
            />
          )}
        </>
      )}
    </div>
  );
};

export default InstantSearchStatus;
